module.exports = __webpack_public_path__ + "media/images/webpack-3b7bf087cbac835e6f7d4b7dc9711e72.png";